

export enum ReasonTypeEnum {

  Dropped = 1,
  Discharged = 2,
  Disqualified = 3,

}
